// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Models.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';

interface LoginDTO { 
  userName: string | null;
  password: string | null;
  devUserName: string | null;
}
const LoginDTO = {
  create: (initValues?: Partial<LoginDTO> | Record<string, unknown> | null) => {
    return Object.assign(
    {
      userName: null,
      password: null,
      devUserName: null,
    },
    initValues);
  }
};

export default LoginDTO;